<template>
    <div :class="'e5-form-error-summary ' + alertClasses">
    <span class="flex-shrink-0 block w-32 h-32 mr-16 pointer-events-none fill-current text-alert">
        <IconAlertSVG/>
    </span>
        <div class="flex-1">
            <span class="block font-semibold">{{mainText}}</span>
            <span class="block">{{secondaryText}}</span>
        </div>
    </div>
</template>

<script>
import IconAlertSVG from "@/assets/static/icons-src/icon-alert.svg"
export default {
    name: 'AlertSummary',
    components: {
        IconAlertSVG
    },
    props: {
        mainText: {
            type: String,
            required: true
        },
        secondaryText: {
            type: String,
            required: true
        },
        alertClasses: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>

</style>
